import React, { useEffect } from 'react';
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import { useSharedData } from '../../hooks/useSharedData';
import { useVisualFormContext } from '../../contexts/VisualFormContext';
import { useValidationErrors } from 'spark-core-dx/hooks';
import { Dataset, VisualType, Filter, Lock, TextFields, Icon } from "./VisualCreationSteps";


const VisualCreationDialog = () => {
  const { dashboardLib } = useDashboardDomainContext();
  const { datasets, visualTypes } = useSharedData();
  const { visualObject, setVisualObject, closeVisualCreationDialog } = useVisualFormContext();
  const { hasAndShowValidationErrors } = useValidationErrors();


  const isCreate = !visualObject?.VisualId;
  const selectedDatasetA = datasets?.find(ds => ds?._id === visualObject?.DashboardDatasetId);
  const compatibleVisualTypes = selectedDatasetA?.CompatibleVisualTypes ?? [];

  const handleSave = async () => {
    const saveFn = isCreate ? dashboardLib.createVisual : dashboardLib.editVisual;
    return await saveFn(visualObject);
  };

  useEffect(() => {
    if (visualObject) {
      
      setVisualObject(prev => {
        let updated = { ...prev };

        const selectedDataset = datasets?.find(ds => ds?._id === prev?.DashboardDatasetId);
        const compat = selectedDataset?.CompatibleVisualTypes;

        if (!compat?.includes(prev?.Type)) {
          updated.Type = undefined;
        }

        return updated;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualObject?.DatasetNameA, datasets]);

  return (
    <DialogControl
      className={"dashboard-dialog double-wide"}
      openDialog={!!visualObject}
      title={isCreate ? "Design a New Visual" : "Edit Visual"}
      onX={closeVisualCreationDialog}
      onOk={async () => {
        if (!hasAndShowValidationErrors("visual")) {
          let status = await handleSave();
          if (status === 200) {
            closeVisualCreationDialog();
          }
        }
      }}
      okText={isCreate ? "Create" : "Save"}
      cancelText={"Cancel"}
      onCancel={closeVisualCreationDialog}
    >
      <div className="dialog-text">
        <div className="visual-attribute">
          <TextFields fieldName={"Name"} displayName={"Visual Name"} />
        </div>
        <div className="visual-attribute">
          <TextFields fieldName={"Description"} displayName={"Description"} />
        </div>
        <div className="visual-attribute">
          <Icon />
        </div>
      <div className="visual-attribute">  
        <Dataset fieldName="DashboardDatasetId"/>
      </div>
        <div className="visual-attribute">
          <VisualType
            visualTypes={visualTypes?.filter(vt =>
              compatibleVisualTypes?.includes(vt?.ShortName)
            )}
          />
        </div> 
        <div className="visual-attribute">
          <Lock />
        </div>
      </div>
      <div className="dialog-text">
        <div className="visual-attribute">
          <div className="title">Filter Columns</div>
          <Filter selectedDataset={selectedDatasetA} />
        </div>
      </div>
    </DialogControl>
  );
};

export default VisualCreationDialog;
